import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const SvgLink01 = ({ ...props }: SvgIconProps) => (
  <SvgIcon {...props}>
    <path
      d="m12.708 18.364-1.415 1.414a5 5 0 1 1-7.07-7.07l1.413-1.415m12.728 1.414 1.415-1.414a5 5 0 0 0-7.071-7.071l-1.415 1.414M8.5 15.5l7-7"
      stroke="currentColor"
      fill="none"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export default SvgLink01;
